import { Page } from '@/core/architecture'

import { TutorialTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * Tutorial Page
 * Implemented as a practical sample.
 */
export const Tutorial: Page = () => {
  const { state, actions } = useViewModel()

  return <TutorialTemplate state={state} />
}
